/*eslint-disable*/
export default {
    props: {
        answerDuration: Number,
    },
    data() {
        return {
            answerTimer: null,
            answerTime: 0,
        };
    },
    computed: {
        isOlympiad() {
            return this.gameType === 'olympiad';
        },
    },
    methods: {
        startAnswerTimer() {
            if (this.answerDuration) {
                this.answerTimer = setInterval(() => {
                    this.answerTime++;
                    if (this.answerTime === this.answerDuration) {
                        this.processReply(true);
                    }
                }, 1000);
            }
        },
        stopAnswerTimer() {
            if (this.answerDuration) {
                this.answerTime = 0;
                clearInterval(this.answerTimer);
            }
        },
    },
    beforeDestroy() {
        this.stopAnswerTimer();
    },
};
